import React from 'react';

import {
  ACCOUNT_SETTINGS_PATHS,
  ADMIN_GLUE,
  ENTITY_LAUNCH_PATHS,
  HOME_PATH,
  INFERENCE_COMPARE_PATH,
  INFERENCE_PATH,
  ORG_API_KEYS,
  ORG_BILLING,
  ORG_DASHBOARD,
  ORG_PROXY,
  ORG_ROLE_EDIT,
  ORG_ROLES_NEW,
  ORG_SERVICE_ACCOUNTS,
  ORG_SETTINGS,
  ORG_TEAMS,
  ORG_USER_ACTIVITY,
  QUICKSTART_PATH,
  REGISTRY_PATHS,
} from '../../../routes/paths';

export const HOME_SIDEBAR_ROUTES = [
  {
    component: React.lazy(() => import('../HomePageContent/HomePageContent')),
    path: ['/', HOME_PATH],
    exact: true,
  },
  {
    path: QUICKSTART_PATH,
    component: React.lazy(
      () => import('../../../components/QuickStart/QuickStart')
    ),
  },
  {
    path: [...ENTITY_LAUNCH_PATHS],
    component: React.lazy(
      () => import('../../../components/Launch/LaunchContent')
    ),
    exact: true,
  },
  {
    path: [`${INFERENCE_PATH}/:collectionId/:modelId`],
    component: React.lazy(() => import('../../InferenceModelPage')),
    exact: true,
  },
  {
    path: [`${INFERENCE_PATH}/:collectionId?`],
    component: React.lazy(() => import('../../InferencePage')),
    exact: true,
  },
  {
    path: [INFERENCE_COMPARE_PATH],
    component: React.lazy(() => import('../../InferenceComparePage')),
    exact: true,
  },
  {
    path: ACCOUNT_SETTINGS_PATHS,
    component: React.lazy(
      () => import('../../Billing/AccountSettings/AccountSettingsPage')
    ),
    exact: true,
  },
  {
    path: REGISTRY_PATHS,
    component: React.lazy(
      () =>
        import('../../../components/Registries/HomepageSidebarRegistriesRouter')
    ),
    exact: true,
  },
  {
    path: [
      ORG_DASHBOARD,
      ORG_TEAMS,
      ORG_SERVICE_ACCOUNTS,
      ORG_API_KEYS,
      ORG_USER_ACTIVITY,
      ORG_BILLING,
      ORG_ROLES_NEW,
      ORG_ROLE_EDIT,
      ORG_PROXY,
      ORG_SETTINGS,
    ],
    component: React.lazy(() => import('../../OrgDashboard/OrgDashboard')),
    exact: true,
  },
  {
    path: [ADMIN_GLUE],
    component: React.lazy(() => import('../../GlueAdmin/GlueAdminPage')),
    exact: true,
  },
];
